import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = {};

export function useContent(key) {
  const [c, setC] = useState(cache[key] || null);
  useEffect(() => {
    api.get(`/content/${key}`).then((r) => { cache[key] = r.data; setC(r.data); }).catch(() => {});
  }, [key]);
  return c;
}
